import { Suspense } from 'react';

import SharedSurveyPosthogPageviewInner from './shared-survey-posthog-pageview-inner';

export default function SharedSurveyPosthogPageview() {
  return (
    <Suspense fallback={null}>
      <SharedSurveyPosthogPageviewInner />
    </Suspense>
  );
}
